// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/articoli-preconfigurati?societaId={id}&q={q}',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","codice":"string","nome":"string","umVenditaSimbolo":"string"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/nominativi/cerca-clienti?societaId={id}&q={q}',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","ragioneSociale":"string","nome":"string","cognome":"string","partitaIva":"string","codiceFiscale":"string","cliente":{"condizionePagamentoId":"number","condizionePagamento":{"id":"number","nome":"string","canale":"string"}}}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/articoli?societaId={id}&q={q}&limit=50',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","codice":"string","descrizioneBase":"string","tipologia":"string","umVendita":{"simbolo":"string"}}],"total":"number"}'
  },
  {
    method: 'GET',
    endpoint: '/api/capitolati?societaId={id}&attivo=true',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","codice":"string","nome":"string"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/capitolati/:id',
    requestBody: null,
    response: '{"success":true,"data":{"id":"number","righe":[]}}'
  },
  {
    method: 'GET',
    endpoint: '/api/nominativi/opzioni/condizioni-pagamento?societaId={id}',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","nome":"string","canale":"string","societaId":"number"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/sedi/mie?societaId={id}&commerciale=true',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","nome":"string"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/offerte-capitolato/:id',
    requestBody: null,
    response: '{"success":true,"data":{"id":"number","codice":"string","ricarico":"string","tipoFatturazione":"string","condizionePagamentoId":"number","condizionePagamento":{"id":"number","nome":"string","canale":"string"},"righe":[{"scorporo":"string"}],"righeAccessorie":[{"scorporo":"string"}]}}'
  },
  {
    method: 'POST',
    endpoint: '/api/offerte-capitolato',
    requestBody: '{"societaId":"number","oggetto":"string","clienteNome":"string","ricarico":"number","tipoFatturazione":"string","condizionePagamentoId":"number","righe":[{"scorporo":"number"}]}',
    response: '{"success":true,"data":{"id":"number","codice":"string","condizionePagamentoId":"number","condizionePagamento":{"id":"number","nome":"string","canale":"string"}}}'
  },
  {
    method: 'PUT',
    endpoint: '/api/offerte-capitolato/:id',
    requestBody: '{"oggetto":"string","ricarico":"number","tipoFatturazione":"string","condizionePagamentoId":"number","righe":[{"scorporo":"number"}]}',
    response: '{"success":true,"data":{"condizionePagamentoId":"number","condizionePagamento":{"id":"number","nome":"string","canale":"string"}}}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
